import { Link } from '@exam-center/router';
import {
  Flex,
  Text,
  List,
  ListItem,
  KeyboardArrowRightRoundedIcon,
  Alert,
  AlertTitle,
} from '@shared/components';

interface ExamLocationRequestSubmitErrorAlertProps {
  examCenterCode: string;
  roomRequestId: string;
  hasComputerInfoError?: boolean;
  hasPhysicalInfoError?: boolean;
}

export default function ExamLocationRequestSubmitErrorAlert({
  examCenterCode,
  roomRequestId,
  hasComputerInfoError,
  hasPhysicalInfoError,
}: ExamLocationRequestSubmitErrorAlertProps) {
  if (!hasComputerInfoError && !hasPhysicalInfoError) {
    return null;
  }

  return (
    <Alert
      severity='error'
      sx={{
        alignItems: 'flex-start',
        '& .MuiAlert-message': {
          overflow: 'unset',
        },
      }}
    >
      <AlertTitle
        variant='body1Semibold'
        sx={(theme) => ({
          m: theme.spacing(0),
          fontWeight: 600,
        })}
      >
        ไม่สามารถส่งคำขออนุมัติได้
      </AlertTitle>
      <Flex sx={{ mt: 1, flexDirection: 'column', gap: 1 }}>
        <Text variant='body2'>กรุณากรอกข้อมูลห้องสอบต่อไปนี้ให้ครบถ้วน:</Text>
        <RoomErrorInfo
          key={roomRequestId}
          examCenterCode={examCenterCode}
          roomRequestId={roomRequestId}
          hasComputerInfoError={hasComputerInfoError}
          hasPhysicalInfoError={hasPhysicalInfoError}
        />
      </Flex>
    </Alert>
  );
}

interface RoomErrorInfoProps {
  examCenterCode: string;
  roomRequestId: string;
  hasComputerInfoError?: boolean;
  hasPhysicalInfoError?: boolean;
}

function RoomErrorInfo({
  examCenterCode,
  roomRequestId,
  hasComputerInfoError,
  hasPhysicalInfoError,
}: RoomErrorInfoProps) {
  return (
    <Flex sx={{ flexDirection: 'column', gap: 1 }}>
      <List
        sx={{
          p: 0,
          pl: 6,
          listStyleType: 'disc',
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        {hasPhysicalInfoError ? (
          <ListItem sx={(theme) => ({ display: 'list-item', p: 0, ...theme.typography.body2 })}>
            กรุณากรอกข้อมูลลักษณะทางกายภาพ{' '}
            <Link
              to='/:examCenterCode/exam-location/requests/:roomRequestId/physical-info'
              params={{ examCenterCode, roomRequestId }}
            >
              <Flex sx={{ display: 'inline-flex', alignItems: 'center', ml: 2 }}>
                <Text variant='body2' sx={{ textDecoration: 'underline', color: 'error.darker' }}>
                  ดูรายละเอียด
                </Text>
                <KeyboardArrowRightRoundedIcon sx={{ fontSize: 20, color: 'error.darker' }} />
              </Flex>
            </Link>
          </ListItem>
        ) : null}

        {hasComputerInfoError ? (
          <ListItem sx={(theme) => ({ display: 'list-item', p: 0, ...theme.typography.body2 })}>
            กรุณากรอกข้อมูลเกี่ยวกับอุปกรณ์คอมพิวเตอร์
            <Link
              to='/:examCenterCode/exam-location/requests/:roomRequestId/computer-info'
              params={{ examCenterCode, roomRequestId }}
            >
              <Flex sx={{ display: 'inline-flex', alignItems: 'center', ml: 2 }}>
                <Text variant='body2' sx={{ textDecoration: 'underline', color: 'error.darker' }}>
                  ดูรายละเอียด
                </Text>
                <KeyboardArrowRightRoundedIcon sx={{ fontSize: 20, color: 'error.darker' }} />
              </Flex>
            </Link>
          </ListItem>
        ) : null}
      </List>
    </Flex>
  );
}
